import styles from "./Guidelines.module.css"

const GuidelinesContent = ({ guidelines }: { guidelines: string }) => (
  <div
    className={styles.Guidelines}
    dangerouslySetInnerHTML={{
      __html: guidelines,
    }}
  />
)

export default GuidelinesContent
